import cena1 from '../assets/imagens/questao_final/1.png'
import cena2 from '../assets/imagens/questao_final/2.png'
import cena3 from '../assets/imagens/questao_final/3.png'
import cena4 from '../assets/imagens/questao_final/4.png'
import cena5 from '../assets/imagens/questao_final/5.png'
import cena6 from '../assets/imagens/questao_final/6.png'


export const cenas = [
    {
        id: 1,
        cena: cena1
    },
    {
        id:2,
        cena: cena2
    }
    ,
    {
        id:3,
        cena: cena3
    }
    ,
    {
        id:4,
        cena: cena4
    }
    ,
    {
        id:5,
        cena: cena5
    }
    ,
    {
        id:6,
        cena: cena6
    }

]